module.exports = __webpack_public_path__ + "static/media/dark-blue-tick.f5029b31.svg";